<template>
  <!--begin::Dashboard-->


  <div id="dnn_ctr464_ModuleContent" class="DNNModuleContent ModDNNHTMLC">
    <div id="dnn_ctr464_HtmlModule_lblContent" class="Normal">
      <div class="pageBg mt-10" data-aos="fade-up">
        <div class="container mt-20">
          <main class="main">
            <div class='container-fluid'>
              <div class="min-h-700px mt-20">
                <div class="row">
                  <div class="col-md-12 mt-20">
                    <div class="row mt-20">
                      <div class="col-12">
                        <div class="qualification_container mt-20">
                          <div class="qualification_tabs">
                            <div @click="goToPrograms"
                                 class="qualification_button button--flex qualification_active">
                              <i class="uil uil-books   qualification_icon"></i>
                              <span class="fs-2 m-1 fw-bolder "
                                    style="color: #7c8b9a">{{$t('all_programs')}}</span>
                            </div>

                            <div @click="goToMyPrograms"
                                 class="qualification_button button--flex">
                              <i class="uil uil-award  qualification_icon"></i>
                              <span class="fs-2 m-1 fw-bolder  ">{{$t('my_programs')}}</span>
                            </div>
                            <div
                              class="qualification_button button--flex">
                              <i class="uil uil-file text-danger qualification_icon"></i>
                              <span class="fs-2 m-1 fw-bolder  text-dark">{{$t('result_page')}}</span>
                            </div>


                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="loading">
                        <div
                          class="row justify-content-center  mx-auto">
                          <div class="col-12 text-center mb-10"></div>
                          <div class="col-md-12 mb-10 text-center">
                            <paragraph-shimmer :lines="3" :random-size="true"/>
                          </div>
                        </div>
                      </div>

                      <div v-if="!loading && !items.length" class="col-md-12 text-center">
                        <div style="width: 320px;margin: auto">
                          <client-only>
                            <Vue3Lottie
                              animationLink="https://assets5.lottiefiles.com/packages/lf20_rc6CDU.json"
                            />
                          </client-only>
                        </div>
                        <br>
                        <h4 class="mt-10">{{$t('no_announced')}}</h4>
                      </div>

                      <!--                                            <div class="col-md-3">-->

                      <!--                                              <div class="text-center mt-2" v-if="securityGateQrCodeDataStr">-->
                      <!--                                                <div class="alert alert-danger">-->
                      <!--                                                  {{ $t('qr_gate') }}-->
                      <!--                                                </div>-->
                      <!--                                                <qrcode-vue :value="securityGateQrCodeDataStr" :size="260" level="H" />-->
                      <!--                                              </div>-->
                      <!--                                            </div>-->
                      <div class="col-md-12" v-if="!loading">
                        <ul class="linksList row large blackShadow redLink">
                          <li class="col-md-12 text-start mb-4" v-for="(item,key) in items">
                            <div data-aos="fade-left"
                                 class="card"
                                 data-bs-toggle='modal'
                                 data-bs-target='#show_show_modal'
                                 v-if="item.messageFlag == 'MSG_03'"
                                 @click="showModalPrograms(item)">
                              <div v-if="item.programDoc">
                                <slot v-if="i18n.locale.value == 'ar'">
                                  <h2 class="text-start p-3">
                                    {{item.programDoc.name.ar}}</h2>
                                </slot>
                                <slot v-if="i18n.locale.value == 'en'">
                                  <h2 class="text-start p-3">
                                    {{item.programDoc.name.en}}</h2>
                                </slot>
                              </div>
                              <div v-if="item.lastFiltrationTest">
                                <slot v-if="i18n.locale.value == 'ar'">
                                  <h4 class="text-start p-3">{{$t('filteration')}} :
                                    {{item.lastFiltrationTest.name.ar}}</h4>
                                </slot>
                                <slot v-if="i18n.locale.value == 'en'">
                                  <h4 class="text-start p-3">{{$t('filteration')}} :
                                    {{item.lastFiltrationTest.name.en}}</h4>
                                </slot>
                              </div>
                              <!--                                                          <div class="text-center mt-2" v-if="securityGateQrCodeDataStr">-->
                              <!--                                                            <div class="alert alert-danger p-0">-->
                              <!--                                                              {{ $t('qr_gate') }}-->
                              <!--                                                            </div>-->
                              <!--                                                            <qrcode-vue :value="securityGateQrCodeDataStr" :size="260" level="H" />-->
                              <!--                                                          </div>-->
                              <button class="btn btn-danger float-start">
                                <i class="uil uil-eye"></i>
                                {{$t('show_details')}}
                              </button>
                            </div>
                            <div data-aos="fade-left"
                                 class="card"
                                 v-else>
                              <div v-if="item.programDoc">
                                <slot v-if="i18n.locale.value == 'ar'">
                                  <h2 class="text-start p-3">
                                    {{item.programDoc.name.ar}}</h2>
                                </slot>
                                <slot v-if="i18n.locale.value == 'en'">
                                  <h2 class="text-start p-3">
                                    {{item.programDoc.name.en}}</h2>
                                </slot>
                              </div>
                              <div v-if="item.lastFiltrationTest">
                                <slot v-if="i18n.locale.value == 'ar'">
                                  <h4 class="text-start p-3">{{$t('filteration')}} :
                                    {{item.lastFiltrationTest.name.ar}}</h4>
                                </slot>
                                <slot v-if="i18n.locale.value == 'en'">
                                  <h4 class="text-start p-3">{{$t('filteration')}} :
                                    {{item.lastFiltrationTest.name.en}}</h4>
                                </slot>
                              </div>

                              <div v-if="item.messageFlag == 'MSG_01'">
                                <template v-if="i18n.locale.value == 'ar'">
                                  <div class="p-2"
                                       style="font-size: 14px;font-weight: bold">
                                    برجاء انتظار اعلان نتيجة المرحلة الحالية..
                                    <div> تمنياتنا بالتوفيق</div>
                                    <div> الأكاديمية الوطنية للتدريب</div>
                                  </div>
                                </template>
                                <template v-if="i18n.locale.value == 'en'">
                                  <div class="p-2"
                                       style="font-size: 14px;font-weight: bold">
                                    Please wait until the current stage's results
                                    are announced..
                                    <div>Best wishes,</div>
                                    <div>National Academy for Training</div>
                                  </div>
                                </template>
                              </div>

                              <div v-if="item.messageFlag == 'MSG_02'">
                                <template v-if="i18n.locale.value == 'ar'">
                                  <div class="p-2"
                                       style="font-size: 14px;font-weight: bold">
                                    سيتم التواصل معكم فور البدء فى إجراءات القبول
                                    الخاصة بالبرنامج..
                                    <div> تمنياتنا بالتوفيق</div>
                                    <div> الأكاديمية الوطنية للتدريب</div>
                                  </div>
                                </template>
                                <template v-if="i18n.locale.value == 'en'">
                                  <div class="p-2"
                                       style="font-size: 14px;font-weight: bold">
                                    We will contact you once the admission process
                                    begins...
                                    <div>Best wishes,</div>
                                    <div>National Academy for Training</div>
                                  </div>
                                </template>
                              </div>

                              <div v-if="item.messageFlag == 'MSG_04'">
                                <template v-if="i18n.locale.value == 'ar'">
                                  <div class="p-2"
                                       style="font-size: 14px;font-weight: bold">
                                    نأسف لعدم مطابقة ملفكم لشروط القبول عند بدء
                                    تصفيات الدفعة الحالية،
                                    يمكنكم تعديل ملفكم وسيتم التواصل معكم في حالة
                                    مطابقتكم لشروط القبول عند فتح باب التقدم
                                    بالدفعات القادمة..
                                    <br>
                                    تمنياتنا بالتوفيق
                                    <br>
                                    الأكاديمية الوطنية للتدريب
                                  </div>
                                </template>
                                <template v-if="i18n.locale.value == 'en'">
                                  <div class="p-2"
                                       style="font-size: 14px;font-weight: bold">
                                    We regret that your application does not meet
                                    the admission requirements for this program,
                                    You will be contacted for the upcoming batches
                                    if your updated profile meets the selection
                                    criteria.
                                    <br>
                                    Best wishes,

                                    <br>
                                    National Training Academy

                                  </div>
                                </template>
                              </div>

                              <div v-if="item.messageFlag == 'MSG_05'">
                                <template v-if="i18n.locale.value == 'ar'">
                                  <div class="p-2"
                                       style="font-size: 14px;font-weight: bold">
                                    نقدر ونثمن مجهودكم ووقتكم الذي بذلتموه في التقدم
                                    للبرامج التدريبية بالأكاديمية الوطنية للتدريب..
                                    لكننا نأسف لعدم اجتياز ملفكم مراحل التصفيات
                                    المؤهلة للإلتحاق بالبرنامج..
                                    وسيكون فريق الأكاديمية على تواصل دائم معكم من
                                    خلال الموقع الرسمي للأكاديمية الوطنية للتدريب

                                    <a class="btn btn-link text-start"
                                       style="padding: 0;color:#409eff;background: transparent;font-weight: bolder"
                                       href="https://www.nta.eg">www.nta.eg</a>

                                    أو من خلال موقع التسجيل الالكتروني

                                    <a class="btn btn-link text-start"
                                       style="padding: 0;color:#409eff;background: transparent;font-weight: bolder"
                                       href="https://register.nta.eg/">https://register.nta.eg/</a>
                                    <div> تمنياتنا بالتوفيق</div>

                                    <div>الأكاديمية الوطنية للتدريب</div>
                                  </div>
                                </template>
                                <template v-if="i18n.locale.value == 'en'">
                                  <div class="p-2"
                                       style="font-size: 14px;font-weight: bold">
                                    Your time and efforts in applying for the
                                    training programs of the National Training
                                    Academy are greatly appreciated..
                                    But, We regret to notify you that your
                                    application did not pass the qualifying stages
                                    for admission to the program.
                                    You will maintain constantly in touch with NTA
                                    team via the National Training Academy's
                                    official website,
                                    <a class="btn btn-link text-start"
                                       style="padding: 0;color:#409eff;background: transparent;font-weight: bolder"
                                       href="https://www.nta.eg">www.nta.eg</a>
                                    In addition, through the registration website
                                    <a class="btn btn-link text-start"
                                       style="padding: 0;color:#409eff;background: transparent;font-weight: bolder"
                                       href="https://register.nta.eg/">https://register.nta.eg/</a>
                                    <div> Our best wishes!</div>

                                    <div>National Training Academy</div>
                                  </div>
                                </template>
                              </div>

                              <button v-if="item.messageFlag == 'MSG_03'"
                                      class="btn btn-danger float-start">
                                <i class="uil uil-eye"></i>
                                {{$t('show_details')}}
                              </button>
                            </div>
                          </li>
                        </ul>
                        <hr>
                      </div>
                    </div>

                    <div class="text-center justify-content-center" dir="ltr">
                      <v-pagination
                        v-model="page"
                        :pages="totalPages"
                        :range-size="pageLimit"
                        active-color="#DCEDFF"
                        @update:modelValue="updateHandler"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <div class="cloudsTop"></div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='show_show_modal' tabindex='-1' role='dialog' ref="ModalShow"
         aria-labelledby='show_users_modalLabel' aria-hidden='true'>
      <div class='modal-dialog modal-lg' role='document'>
        <div class='modal-content'>
          <div class='modal-header'>
            <h2 class='modal-titles text-danger' id='show_show_modalLabel' v-if="currentItem">
              <slot v-if="currentItem.programDoc">
                <slot v-if="i18n.locale.value == 'ar'">
                  <h4>{{currentItem.programDoc.name.ar}}</h4>
                </slot>
                <slot v-if="i18n.locale.value == 'en'">
                  <h4>{{currentItem.programDoc.name.en}}</h4>
                </slot>
              </slot>
            </h2>

            <!--begin::Close-->
            <div class='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
                            <span class='svg-icon svg-icon-1'>
                              <inline-svg src='media/icons/duotune/arrows/arr061.svg'/>
                            </span>
            </div>
            <!--end::Close-->
          </div>
          <div class='modal-body'>
            <div v-if='!currentItem' class='d-flex justify-content-center align-items-center text-center'>
              {{$t('no_announced')}}
            </div>

            <div v-if="currentItem">
              <slot v-if="currentItem.lastFiltrationTest">
                <slot v-if="i18n.locale.value == 'ar'">
                  <h4>{{$t('filteration')}} : {{currentItem.lastFiltrationTest.name.ar}}</h4>
                </slot>
                <slot v-if="i18n.locale.value == 'en'">
                  <h4>{{$t('filteration')}} : {{currentItem.lastFiltrationTest.name.en}}</h4>
                </slot>
              </slot>
              <hr>
              <div class="min-w-350px">
                <div class="table-responsive">
                  <table class="table align-middle table-row-dashed fs-6 text-gray-600 fw-bold gy-5">
                    <tbody>
                    <tr v-for="(stage,stageKey) in currentItem.lastFiltrationTestStagesWithPublishExamDetailsTrue || []"
                        :key="stageKey"
                        style="border-bottom: 1px dashed #2e2e2e">
                      <td>
                        <div>
                          <b class="text-dark">
                            <slot v-if="i18n.locale.value == 'ar'">
                              {{stage.name.ar}}
                            </slot>
                            <slot v-if="i18n.locale.value == 'en'">
                              {{stage.name.en}}
                            </slot>
                          </b>
                        </div>
                        <div v-if="stage.candidateExamDetails && stage.candidateExamDetails.examTimeNote"
                             style="text-align: justify">
                          <div v-html="stage.candidateExamDetails.examTimeNote"></div>
                        </div>
                        <div class="text-dark" style="font-weight: bold"
                             v-if="stage.candidateExamDetails && stage.candidateExamDetails.examTimeAt">
                          {{$t('examTimeAt')}} :
                          {{$helpers.formatDate(stage.candidateExamDetails.examTimeAt,'YYYY-MM-DD HH:mm')}}
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="text-center mt-2" v-if="securityGateQrCodeDataStr && QRCode ">
                    <div class="alert alert-danger">
                      {{ $t('qr_gate') }}
                    </div>
                    <qrcode-vue :value="securityGateQrCodeDataStr" :size="260" level="H"/>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class='modal-footer' v-if="currentItem">
            <button type='button' class='btn btn-sm btn-secondary' data-bs-dismiss='modal'
                    @click='currentItem=null'>
              {{ $t('close') }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!--end::Dashboard-->
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, toRefs, ref, unref, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import AOS from 'aos';
import VPagination from '@hennge/vue3-pagination';
import { hideModal } from '@/core/helpers/dom';
import '@hennge/vue3-pagination/dist/vue3-pagination.css';
import StorageService from '@/core/services/StorageService';
import * as _ from 'lodash';
import QrcodeVue from 'qrcode.vue';

export default defineComponent({
  name: 'all_programs',
  components: {
    VPagination,
    QrcodeVue,
  },
  setup() {
    const helpers: any = inject('helpers');
    const store = useStore();
    const router = useRouter();
    const i18n = useI18n();
    const { t } = useI18n();

    const ModalShow = ref<HTMLElement | null>(null);

    onMounted(() => {
      AOS.init();
      getAllProgramsResult();
      getProfile();
    });

    const state = reactive({
      loading: false,
      currentItem: null,
      acceptTerms: false,
      page: 1,
      totalPages: 1,
      pageLimit: 10,
      items: [],
      securityGateQrCodeDataStr: '',
      QRCode: true,
    });

    const updateHandler = (e) => {
      state.page = e;
      getAllProgramsResult();
    };
    const getAllProgramsResult = () => {
      state.loading = true;
      state.items = [];
      let payload = {
        paginated: true,
        limit: state.pageLimit,
        page: state.page,
      };
      setTimeout(() => {
        store.dispatch('modulePrograms/listUserProgramResults', payload)
          .then(({ data }) => {
            state.loading = false;
            let response = data.data;
            state.items = response.docs;
            state.totalPages = response.totalPages;
          })
          .catch((response) => {
            state.loading = false;
            helpers.handleResponse(response, t, router, store, {});
          });
      }, 100);
    };

    const showModalPrograms = (item: any) => {
      state.acceptTerms = false;

      // Ensure lastFiltrationTestStagesWithPublishExamDetailsTrue is an array
      const stages = item.lastFiltrationTestStagesWithPublishExamDetailsTrue;
      if (Array.isArray(stages) && stages.length > 0) {
        // Get the last object in the array
        const lastObject = stages[stages.length - 1];

        // Safely check if the QRCode field exists and assign its value
        state.QRCode = lastObject && 'QRCode' in lastObject ? lastObject.QRCode : true;
      }
      state.currentItem = item;
    };

    const goToApplyPrograms = (item) => {
      hideModal(ModalShow.value);
      // let dynamicFormsJsonWithOrder: any = item.dynamicFormsJsonWithOrder[0];
      router.push({ name: 'apply_program_page', params: { id: item._id } });
    };

    const goToPrograms = () => {
      router.push({ name: 'all_programs_page' });
    };
    const goToMyPrograms = () => {
      router.push({ name: 'my_programs_page' });
    };

    const getProfile = () => {

      store.dispatch('moduleAuth/verify')
        .then(({ data }) => {
          state.loading = false;
          let response = data.data;
          state.securityGateQrCodeDataStr = JSON.stringify(response.securityGateQrCodeData);
        })
        .catch((response) => {
          state.loading = false;
          helpers.handleResponse(response, t, router, store, {});
        });
    };
    return {
      ...toRefs(state),
      router,
      ModalShow,
      i18n,
      store,
      updateHandler,
      showModalPrograms,
      goToApplyPrograms,
      goToPrograms,
      goToMyPrograms,
    };
  },
});
</script>
<style>
.Pagination {
  justify-content: center;
  list-style: none !important;
}
</style>
